import React from 'react'

const BdAddress = () => {
  return (
    <div className='border p-8 bg-blue-100 w-full'>
      <div className='flex flex-col md:flex-row justify-between items-center'>
        <div>
          <h1>Street: 17/4 Dhanmondi.</h1>
          <h1>City: Dhaka</h1>
          <h1>Phone: +8801622222456</h1>
          <h1>Email: contact.bd@cc.com</h1>
        </div>
        <div>
          <h1 className='text-2xl'>BANGLADESH OFFICE</h1>
        </div>
      </div>
    </div>
  )
}

export default BdAddress
